module.exports = __webpack_public_path__ + "img/Hüte.5cdf4247.svg";